import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {NgIf} from "@angular/common";
import {SharedModule} from "../../../../shared/shared.module";
import {SvgIconComponent} from "angular-svg-icon";
import {UserComponent} from "../../../../shared/user/user.component";
import {DataColumn} from "../../../../models";
import {ReferenceTitleComponent} from "../../agency-etab-missions-details/reference-title/reference-title.component";
import {
  CandidaturesMissionComponent
} from "../../agency-etab-missions-details/encour-component/components/candidatures-mission/candidatures-mission.component";
import {
  TableEnCourActionComponent
} from "../../agency-etab-missions-details/encour-component/components/table-en-cour-action/table-en-cour-action.component";
import {Mission} from "../../../../models/Mission";
import {Site} from "../../../../models/Site";
import moment from "moment/moment";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {MissionService} from "../../../../services/mission.service";
import {EstablishmentService} from "../../../../services/establishment.service";
import {AuthService} from "../../../../services/auth.service";
import {debounceTime, skip} from "rxjs";
import {removeBlankAttributes} from "../../../../shared/utils/utils.functions";
import {
  MissionDetailsComponent
} from "../../agency-etab-missions-details/encour-component/mission-details/mission-details.component";
import {
  MissionTableActionsComponent
} from "../../agency-etab-missions-details/encour-component/components/mission-table-actions/mission-table-actions.component";
import { MissionCandidateTableActionsComponent } from '../../agency-etab-missions-details/encour-component/components/mission-candidate-table-actions/mission-candidate-table-actions.component';
import {filterListDoneInterim, filterListForCandidate} from "../../../../shared/utils/data/etablissments-data";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";

@Component({
  selector: 'app-agency-in-progress-mission-for-candidate',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    NgIf,
    ReactiveFormsModule,
    SharedModule,
    SvgIconComponent,
    NgxIntlTelInputModule
  ],
  templateUrl: './agency-in-progress-mission-for-candidate.component.html',
  styleUrl: './agency-in-progress-mission-for-candidate.component.scss'
})
export class AgencyInProgressMissionForCandidateComponent implements OnInit {
  component: any[] = [UserComponent];
  isLoading: boolean = false;
  customColumns: DataColumn[] = [
    {
      header: 'Référence',
      fieldName: 'missionTitle',
      component: ReferenceTitleComponent,
      dataType: 'component',
      col: 'col',
    },
    {header: 'Site', fieldName: 'site', dataType: 'string', col: 'col',},
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectationsName',
      dataType: 'string',
      col: 'col',
    },
    {header: 'Poste', fieldName: 'typePoste', dataType: 'string', col: 'col',},
    {
      header: 'Type de contrat',
      fieldName: 'typecontat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Statut',
      fieldName: '',
      component: TableEnCourActionComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
    {
      header: 'Actions',
      fieldName: '',
      component: MissionCandidateTableActionsComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
      detailsOnly: true,
    },
  ];
  id: number;
  missionList: Mission[] = [];
  offset = 0;
  size = 10;
  totalItems = 0;
  private typePosteId: any;
  missionListFiltered: Mission[];
  totalItemsAfterFilter: number;
  selectedSite: null= null;
  siteList: any[] = []
  statusOfCandidatOnMissionList: any[] = []
  inputSearch: string = '';

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private api: MissionService,
    private fb: FormBuilder
  ) {
    this.id = this.route.snapshot.params['candidatId'] ?? 0;
    this.typePosteId = this.route.snapshot.params['typePosteId'] ?? 0;
  }

  ngOnInit(): void {
    this.fetshMission();
    // Refresh the table whenever an action mutates a mission (cancel, delete, status change…).
    this.api.getRefreshMission().pipe(skip(1)).subscribe(() => this.fetshMission());
  }

  fetshMission(): void {
    this.isLoading = true;
    this.api
      .getCurrentMissions(this.id, this.typePosteId, this.offset, this.size)
      .subscribe({
        next: (res: any) => {
          this.missionList = res.missions.map((mission: any) => {
            if (mission.typecontat == 'LIBERAL') {
              mission.typecontat = 'Intérim'
            }
            mission.site = mission?.adresseDto?.name ?? '';
            mission.isUrgent = mission?.isurgent;
            return mission
          });
          this.totalItems = res.totalItems;
          this.siteList = Array.from(
            new Map(
              this.missionList.map((m: any) => [m.adresseDto.id, { name: m.adresseDto.name, id: m.adresseDto.id }])
            ).values()
          );
          this.invokeSearchFilter();
        },
        error: () => {},
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleRowClick = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: {right: '0'},
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.fetshMission();
      }
    });
  };

  pagination(event: any) {
    // Backend uses PageRequest.of(offset, size) → offset is the 0-based PAGE index, not a row offset.
    this.offset = event.pageIndex;
    this.fetshMission();
  }

  searchItem(event: any) {
    if(!!event) {
      this.inputSearch = event.target.value.trim().toLowerCase();
      this.offset = 0;
      this.invokeSearchFilter();
    }
  }

  toggleSelectSite(event: any, item: any) {
    if (event) {
      this.selectedSite = item.id;
    } else {
      this.selectedSite = null;
    }
    this.invokeSearchFilter();
  }

  private invokeSearchFilter() {
    this.missionListFiltered  = [...this.missionList];

    if (!!this.inputSearch) {
      this.missionListFiltered =this.missionListFiltered.filter((e: any) => {
        return (
          e.missionTitle?.toLowerCase().includes(this.inputSearch)
        );
      });
    }

    if (!!this.selectedSite) {
      this.missionListFiltered = this.missionListFiltered.filter((e: any) => {
        return ( e.adresseDto.id == this.selectedSite );
      });
    }

    if (!!this.statusOfCandidatOnMissionList && this.statusOfCandidatOnMissionList.length > 0) {
      this.missionListFiltered = this.missionListFiltered.filter((e: any) => {
        return (  this.statusOfCandidatOnMissionList.includes(e.statusOfCandidatOnMission) );
      });
    }

    // Le serveur pagine : sans filtre local, le paginateur doit recevoir le TOTAL du serveur. Avec le nombre de lignes de la page
    // courante (ancien comportement), au-delà de 10 missions les pages suivantes étaient inaccessibles.
    const clientFilterActive = !!this.inputSearch || !!this.selectedSite || (this.statusOfCandidatOnMissionList?.length ?? 0) > 0;
    this.totalItemsAfterFilter = clientFilterActive ? this.missionListFiltered.length : this.totalItems;
  }

  protected readonly filterListDone = filterListForCandidate;

  handleStatusChange(status: MatSelectChange) {
    const statusOfCandidatOnMission = status.value;
    this.statusOfCandidatOnMissionList = statusOfCandidatOnMission;
    this.invokeSearchFilter();
  }
}
